import {Suspense} from 'react';
import {Outlet} from 'react-router-dom';

import {LegalDocumentSkeleton} from '@/features/legal';

import {AppLogo} from './AppLogo';

import type {FC} from 'react';

export const LegalLayout: FC = () => {
  return (
    <div className="flex min-h-dvh flex-col bg-background-surface">
      <header
        data-slot="legal-topbar"
        className="flex h-16 shrink-0 items-center border-b border-border px-6 lg:px-10"
      >
        <AppLogo />
      </header>
      <main data-slot="legal-content" className="flex-1 overflow-y-auto">
        <Suspense fallback={<LegalDocumentSkeleton />}>
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
};
